<template>
  <div class="new-strip">
    <upload-strip-image @complete="complete" />
  </div>
</template>

<script>
import parseFilename from '@/utilities/parseFilename';
import UploadStripImage from './UploadStripImage.vue';

export default {
  name: 'NewStrip',
  components: {
    UploadStripImage,
  },
  data() {
    const { publishDate } = this.$route.params;
    return {
      publishDate,
    };
  },
  methods: {
    complete({ file, images }) {
      const strip = parseFilename(file.name);
      const milliseconds = this.publishDate && new Date(this.publishDate).getTime();
      const publishDate = {
        seconds: milliseconds && (milliseconds / 1000),
      };
      this.$emit('upload', {
        ...strip,
        ...images,
        publishDate,
        free: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.new-strip {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
